import { useEffect, useState } from 'react';
import api from '../lib/api.ts';           // adjust path
import { useLanguage } from '../context/LanguageContext';

import { AboutHero } from '../components/newabout/about-hero';
import { AboutContent } from '../components/newabout/about-content';
import { ValuesSection } from '../components/newabout/values-section';
import { TeamSection } from '../components/newabout/team-section';
// import CtaSection     from '../components/newabout/cta-section';  // if you add it later
import usePageMeta from '../hooks/usePageMeta';

export default function AboutPage() {
  const { language } = useLanguage();
  usePageMeta("about_us");

  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        setLoading(true);
        const res = await api.get('/pagesettings/about-us', {
          params: { lang: language }
        });

        setPageData(res.data);
      } catch (err) {
        console.error("Failed to load About page data:", err);
        setError("Failed to load page content");
      } finally {
        setLoading(false);
      }
    };

    fetchAboutData();
  }, [language]);

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
      </div>
    );
  }

  if (error || !pageData) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center p-8">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4">Something went wrong</h2>
          <p className="text-gray-400">{error || "Content not available"}</p>
        </div>
      </div>
    );
  }

  return (
    <main className="bg-bg-dark text-foreground min-h-screen">
      <AboutHero hero={pageData.about_hero_section?.[0]} stats={pageData.about_hero_stats || []} />
      <AboutContent about={pageData.about_us?.[0]} />
      <ValuesSection
        pillarsHeader={pageData.core_pillars_header?.[0]}
        pillars={pageData.core_pillars || []}
      />
      <TeamSection
        leadershipHeader={pageData.leadership_header?.[0]}
        teamMembers={pageData.leadership_team || []}
        cta={pageData.about_cta_section?.[0]}
      />
      {/* <CtaSection cta={pageData.about_cta_section?.[0]} /> */}
    </main>
  );
}